import { ROUTE__base } from './ROUTE__base';

export function ROUTE__public(path: string, element: React.ReactNode) {
  return ROUTE__base(path, element);
}
